import { SharePointFileLink, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('sharePointFileLinks');
export const findByIdThrows = createFindByIdThrows('sharePointFileLinks');

type GetFulfilledSharePointFileLinks = (state: YammerState) => Record<string, SharePointFileLink>;
export const getFulfilledSharePointFileLinks: GetFulfilledSharePointFileLinks = (state) =>
  state.sharePointFileLinks.fulfilled.byId;
